export default __webpack_public_path__ + "static/media/fb.211980fc.gif";